import { eventBus } from "../eventbus.js";

export default {
    created: function(){
        var vm = this,
            waitingForSync = false,
            registry_record = null,        
            registryIdentifier,
            registryCollection;
        //se è in corso una sync, prima di chiamare la loadBidirectionalData devo aspettare che finisca la sync in modo che non vengano sovrascritti i rec che sono nell'idb
        //listener di "sync completata"
        //se stavo aspettando ovvero waitingForSync=true, chiamo loadBidirectionalData
        //altrimenti niente
        eventBus.$on('syncCompleted',()=>{
            if(waitingForSync){
                vm.$Configs.idCliente = vm.$root.clientSelected;
                registryIdentifier = vm.$root.getRegistryIdentifier();
                registryCollection = vm.$root.dataReferences.getCollection("singleRegistry");
                if(!registryCollection){
                    registryCollection = vm.$root.dataReferences.addCollection("singleRegistry");
                }
                registry_record = registryCollection.find({"name" : registryIdentifier});
                vm.loadBidirectionalData(registry_record, registryIdentifier, registryCollection)
            }
        })

        //listner dell'evento "cliente scelto"--> 
        //controllo executingSync: se true, setto il flag waitingForSync
        //else chiamo la loadBidirectionalData
        eventBus.$on('clientSelected',()=>{
            if(vm.executingSync){
                waitingForSync = true
            }else{
                vm.$Configs.idCliente = vm.$root.clientSelected;
                registryIdentifier = vm.$root.getRegistryIdentifier();
                registryCollection = vm.$root.dataReferences.getCollection("singleRegistry");
                if(!registryCollection){
                    registryCollection = vm.$root.dataReferences.addCollection("singleRegistry");
                }
                registry_record = registryCollection.find({"name" : registryIdentifier});
                vm.loadBidirectionalData(registry_record, registryIdentifier, registryCollection)
            }
        })
    },
    methods: {
        onlineLoadStart(){
            //CARICAMENTI DA EFFETTUARE PRIMA DI INIZIALIZZARE LA VIDEATA
            var vm = this;
            var promises = [];
            var registry_record = null;            // ---  Flag valorizzati solo in caso di indexedDb Pre caricato
            var registryIdentifier;
            var registryCollection
            
            var promises = []
            
            //____________________________________________________Registry obbligatorio:____________________________________________________________________________________________
            //path relativo per evitare dipendenza dall'url attuale quando faccio loadDatabase con la http request
            var registryResolve, registryReject;
            promises.push(new Promise(function(resolve, reject) {
                registryResolve = resolve;
                registryReject = reject
            }).then((res) => {
                // vm.setLoadingMessage(this.$Jed.firstUpperTranslate('registry database loaded', null)+'...')
                // promise per caricamento registry risolta all'interno dell'elaborazione dell'indexed DB
                vm.$root.dbRegistry = res;
                // a questo punto il registry è caricato e sicuramente referenziato nell'indexedDB ---> se impostato da preferenza, eseguo la sync remote
                var isThere =  vm.$root.dbRegistry.getCollection("deletions")
                if(isThere){
                    //dovrebbe esserci sempre la collezione dei record rimossi, ma nel front end devo ignorarla
                    //vm.$root.dbRegistry.removeCollection("deletions")
                }
            }));

            //____________________________________________________Lista catalogs obbligatori:____________________________________________________________________________________________
            //se già presenti in indexedDB, la promise si risolverà subito senza chiamate asincrone
            // la promise ritorna il riferimento all'indexedDB caricato in memoria
            var catalogsResolve, catalogsReject;
            promises.push(new Promise(function(resolve, reject) {
                vm.setLoadingMessage(vm.$Jed.firstUpperTranslate('loading catalogs', null)+'...'); 
                catalogsResolve = resolve;
                catalogsReject = reject
            }).then((res) =>  {
                vm.setLoadingMessage(vm.$Jed.firstUpperTranslate('loading catalogs', null)+'...') 
                // valorizzo token.catalogs nella risoluzione della promise, quando la collection catalogs è sicuramente valorizzata...
                // a prescindere dal fatto che abbia chiamato il servizio, o avessi già i valori dei cataloghi salvati su indexedDB
                var idbCatalogs = res.getCollection("catalogs")
                var arr = idbCatalogs.find();
                for(var i = 0; i < arr.length; i++){
                    var catalogToToken = {
                        id: arr[i].id,
                        version: arr[i].version,
                        date: new Date(arr[i].date).toLocaleDateString(),
                        brand : arr[i].brand,
                        name: arr[i].name,
                        note: vm.$Behaviors.searchCatalogByNotes ? arr[i].name.not : "",
                        file: arr[i].file
                    }
                    vm.$Configs.catalogs.push(catalogToToken)
                }
            }))

            //____________________________________________Dati da richiamare all'inizio per ogni nuova load: ______________________________________________________________________________________
            //sono richieste per dati poco variabili usati in giro per l'applcazione (Es. product types)
            promises.push(this.loadInitialData())

            //____________________________________________IndexedDB per la fruizione offline: ______________________________________________________________________________________
            //uso indexed adapter e partitioning adapter(quest'ultimo per poter gestire db superiori a 60Mb)
    
            /**
             *  creo l'indexedDb
             */
            var promise_idb_msg = this.$Jed.firstUpperTranslate('preparing environment', null)+'...' 
            promises.push(this.loadLoki(vm.$root.dataReferencesDbName, "indexedAdapter", true, true, 4000, null, promise_idb_msg).then((res) => {
                /**
                 *   aggiorno messaggio nella loading page
                 */

                vm.setLoadingMessage(promise_idb_msg); 
    
                /**
                 *   gestione preferenze dell'utente
                 */
                /* 
                var preferences = res.getCollection("preferences");
                if(preferences){
                    res.removeCollection("preferences");
                    preferences = null;
                }
                preferences = res.addCollection("preferences"); */

                if (!res.getCollection("preferences")) { 
                    res.addCollection("preferences");
                }
                var preferences = res.getCollection("preferences")

                var userID = this.$root.token.idUtente;
                var pref = preferences.find({"id" : userID})
                var source = null;
                if(!pref || pref.length == 0){
                    // se non sono già state settate delle preferenze per l'utente, mi copio quelle di default e salvo il record nell'indexDB
                    source = {}
                    for(var prop in front_end_configs.default_preferences){
                        source[prop] = front_end_configs.default_preferences[prop];
                    }
                    source["id"] = userID;
                    preferences.insert(source);
                    //inoltre, se previsto da behavior, mostro la schermata delle preferenze prima del caricamento catalogo
                    vm.$root["showPreferencesAfterLogin"] = false;
                    if(behav.preferencesAfterLogin){
                        this.$root.BLOCK_NAVIGATION = true;
                        vm.$root["showPreferencesAfterLogin"] = true;
                    }
                } else {
                    // altrimenti, mi tengo una copia di sessione separata dal record dell'indexDB 
                    pref[0].useOffline = false //mi assicuro che il flag useOffline usato globalmente sia false (qui sono per forza nell'uso online)
                    pref[0].getAncestors = true
                    source = pref[0];
                    // se non ho mai salvato le preferenze (ho fatto subito logout appena è apparsa la schermata), ripropongo comunque la videata
                    if(!source.savedOnce){
                        vm.$root["showPreferencesAfterLogin"] = false;
                        if(behav.preferencesAfterLogin){
                            vm.$root.BLOCK_NAVIGATION = true;
                            vm.$root["showPreferencesAfterLogin"] = true;
                        }
                    }
                }
                for(var prop in source){
                    vm.$root.preferences[prop] = source[prop];
                }
    
                /**
                 *   predispongo varie collection nell'indexedDB
                 */
                // 1) collection per meta-info notifiche PER OGNI UTENTE
                if (!res.getCollection("userMetaNotifications")) {
                    res.addCollection("userMetaNotifications");
                }
                // 2) collection contenente lo stato delle notifiche non eliminate DISTINTE per utente
                if (!res.getCollection("userNotifications")) {
                    res.addCollection("userNotifications");
                }
                
                /* // 3) collection contenente i brands
                if (!res.getCollection("brands")) {
                    res.addCollection("brands");
                } */
                // 4) collection contenente i cataloghi: 
                // Conterrà i cataloghi a cui può accedere il cliente associato all'utente loggato
                // Questi cataloghi li prendo facendo la richiesta al cmd GetCatalogList
                // In questo modo, nell'indexedDb avrò i cataloghi per cui il cliente dell'utente ha i permessi.
                if (!res.getCollection("catalogs")) { 
                    res.addCollection("catalogs");
                }
    
                /**
                 *   faccio la richiesta ai service per trovare i cataloghi a cui può accedere il cliente dell'utente loggato
                 */
                vm.$root
                    .microservice({
                        role: "authentication",
                        cmd: "GetCatalogList",
                        params: {
                            idAgente: vm.$Configs.idAgente,
                            idCliente: vm.$Configs.idCliente 
                        }
                    })
                    .then(response => {
                        console.log('App.vue - GetCatalogList', response.body)
                        var catalogs = response.body,
                            cat_coll = res.getCollection('catalogs');
                        cat_coll.clear(); // svuoto la collection dei cataloghi in modo da andarla a popolare solo con i cataloghi nuovi appena tornati con la GetCatalogList
                        
                        console.log("CATALOGS EMPTIED")
                        console.log(cat_coll)

                        for(var i=0; i<catalogs.length; i++){
                            //__________________________________________________________________________________________________________________
                            //tra le traduzioni delle descrizioni dei cataloghi utilizzo quella che corrisponde alla lingua corrente
                            var traduzioni = catalogs[i].name.trad, 
                                current_lang,
                                filtered = [],
                                traduzioneIta = catalogs[i].name.des;
                            
                            current_lang = vm.$root.token.siglaLingua;
    
                            if(traduzioni && traduzioni.length>0 && current_lang != 'ITA'){
                                filtered = traduzioni.filter((t)=>{
                                    return t.lid == current_lang
                                })
                            }
                            //__________________________________________________________________________________________________________________
                            
                            var catalog = {
                                id: catalogs[i].id,
                                version: catalogs[i].version,
                                date: new Date(catalogs[i].date).toLocaleDateString(),
                                brand : catalogs[i].brand,
                                name: filtered.length>0 ? filtered[0].des : traduzioneIta,
                                note: vm.$Behaviors.searchCatalogByNotes ? catalogs[i].name.not : "",
                                file: catalogs[i].file
                            }
    
                            cat_coll.insert(catalog);
                        }
                        console.log("CATALOGS INSERTED")
                        console.log(cat_coll)
                        catalogsResolve(res);
                    },
                    err => {
                        vm.loading_screen.finish();
                        //vedi gestione errore in main.js > microservice
                    })
                    .catch(err => {
                        console.log(err);
                        vm.loading_screen.finish();
                        var msg = err && err.body && err.body.error ? err.body.error : ''
                        vm.alertOPT.message = "Application caught an error <br> <h5>Details: " + "authentication.GetCatalogList - " + msg +'</h5>',
                        vm.alertAPI.open();
                    })						   
    
                /**
                 *   caricamento del registry e dell'IndexedDb 
                 */
                registryCollection = res.getCollection("singleRegistry"); // collezione con un solo record per indexedDB
                if(!registryCollection){
                    registryCollection = res.addCollection("singleRegistry");
                }
                // valorizzo dataReferences prima di caricare il registry, in modo da averlo anche in un'eventuale fase di sincronizzazione
                vm.$root["dataReferences"] = res;
    
                //identificativo del registry: se non c'è, è la prima volta che carico il registry nell'indexedDb
                registryIdentifier = vm.$root.getRegistryIdentifier();
                registry_record = registryCollection.find({"name" : registryIdentifier});
                
                var idb;
                //carico subito l'IDb
                vm.loadLoki(registryIdentifier, "indexedAdapter", true, false).then((dbreg)=>{
                    idb = dbreg;     
                    console.log("RESOLVING")
                    registryResolve(idb);    
                    
                },(err) => {
                    console.log('error loading Idb', err)
                    registryReject();
                })
                    
                console.log('dataReferences loki db initialized', res)
            }, (err) => {
                console.log('error loadDatabase dataReferences', err)
            }));

            //____________________________________________________DB Modelli:____________________________________________________________________________________________
            var promise_models_msg = this.$Jed.firstUpperTranslate('loading models', null)+'...'
            promises.push(this.loadLoki(vm.$root.msPath +"/"+ vm.$Configs.licenseId +"/mod/" + vm.$root.token.modelsDb, "fs", false, false, null, null, promise_models_msg).then((res) => {
                vm.setLoadingMessage(promise_models_msg)
                vm.$root.dbModels = res
                console.log('dbModel loki db loaded', res)
            }, (err) => {
                console.log('error loadDatabase dbModel', err)
            }));
    
            //____________________________________________Controllo catalogo pre caricato:____________________________________________________________________________________________
            //se abilitata preferenza OFFLINE, devo creare il loki per il catalogo pre caricato
            var behav = this.$Behaviors;
            var cr = localStorage.getItem("current_root");
            var c = localStorage.getItem("current");
            var cn = localStorage.getItem("current_name");
            var clm = localStorage.getItem("current_loaded_model")
            this.$root.root_index = cr != null && cr != "" ? cr : this.$root.root_index;
            this.$root.index_as_root = c != null && c != "" ? c : this.$root.index_as_root;
            this.$root.root_filename = cn != null && cn != "" ? cn : this.$root.root_filename;
            this.$root.model_of_cat = clm != null && clm != "" ? clm : this.$root.model_of_cat;
            
            // sposto qui il controllo per verificare un catalogo pre-caricato, così posso già creare il Loki se necessario
            if (this.$root.root_index == null || this.$root.root_filename == null) {
                this.$root["openModalSelect"] = true;
                this.$root["emitGotIndex"] = false;
            } else if (this.$root.index_as_root != null) {
                this.$root["openModalSelect"] = false;
                this.$root["emitGotIndex"] = true;
            } else {            
                this.$root["openModalSelect"] = false;
                this.$root["emitGotIndex"] = false;
            }

            Promise.all(promises).then(() => {
                if(vm.onStartData){
                    console.log("Filling initial collection: onStartData -> ", vm.onStartData)
                    for(var prop in vm.onStartData){
                        if (vm.$root.dbRegistry.getCollection(prop)) { 
                            vm.$root.dbRegistry.removeCollection(prop);
                        }
                        var options = vm.getOpts(prop);
                        var c = vm.$root.dbRegistry.addCollection(prop, options);
                        c.insert(vm.onStartData[prop])
                    }
                    //A questo punto sono sicuro che la collection dei product types nel dbRegistry sia valorizzata
                    var productTypesColl = vm.$root.dbRegistry.getCollection('productTypes'),
                        arr = productTypesColl.find();
                    for(var i in arr){
                        vm.$root.prod_icons[arr[i].id] = {icn: arr[i].icn, des: arr[i].des}
                    }

                    var documentTypesColl = vm.$root.dbRegistry.getCollection('documentTypes'),
                        arr = documentTypesColl.find();
                    for(var i in arr){
                        vm.$root.doc_types[arr[i].id] = {icn: arr[i].icn, des: arr[i].des}
                    }
                }
                console.log("RESOURCE LOAD COMPLETE: ", vm.$root.dbRegistry);
                
                vm.RESOURCE_LOAD_COMPLETE = true;
                vm.loading_screen.finish()
                try {
                    document.getElementsByClassName("pg-loading-screen pg-loading")[0].style.display = "none";
                } catch(err){
                    console.log("Error on ensure loadin_screen.finish", err)
                }
                // AT LOAD COMPLETE, INIT ITER NOTIFICATION MANAGER
                vm.$root.notificationManager.initUserNotificationManager();
                vm.$nextTick(function(){
                    eventBus.$emit("RESOURCE_LOAD_COMPLETE_EVENT")
                })
                /* 
                //TODO: check cosa succede se provo ad accedere al carrello e le GEt non hanno ancora risposto
                setTimeout(()=>{
                    vm.loadBidirectionalData(registry_record, registryIdentifier, registryCollection)
                },20000) */

                
                if(vm.$Configs.idCliente && vm.$Configs.idAgente == "null"){ //se sono entrato come non agente, nel token ho l'idCliente definitivo
                    vm.loadBidirectionalData(registry_record, registryIdentifier, registryCollection)
                }
                //se sono entrato come agente devo aspettare che l'utente scelga il cliente per scaricare le collezioni bidirezionali
                //vedi listener dell'evento clientSelected
                
            }, (err) => {
                console.log(err)
                vm.RESOURCE_LOAD_COMPLETE = false;
            });
        },
        loadInitialData: function(){
            var vm = this;
            var promises = [];
            this.onStartData = {}
            var cmdsForCollections = [
                { name:'GetProductTypes', model:'productTypes'},
                { name:'GetDocumentTypes', model:'documentTypes'},
                { name:'GetShippingTypes', model:'shippingTypes'},
                { name:'GetPorts', model:'ports'},
                { name:'GetNations', model:'nations'},
                { name:'GetOrderStatus', model:'orderStatuses'},
                { name:'GetOrderStatusChanges', model:'orderStatusChanges'}/*,
                { name:'GetUserGroups', model:'userGroups'}*/
            ]
            for (let i = 0; i < cmdsForCollections.length; i++) {
                const cmd = cmdsForCollections[i];
                promises.push(vm.$root.microservice({
                    serviceType: "registry",
                    role: "data",
                    cmd: cmd.name,
                    params: {}
                }).then((response) => {
                    var res = response.body;
                    /*try {
                        res = JSON.parse(response.body);
                    } catch (err) {
                        console.log(err)
                        console.log(response)
                    }*/
                    if(res){
                        vm.onStartData[cmd.model] = res
                    }
                }));
            }
            return Promise.all(promises);
        },
        getOpts: function(colName){
            var options;
            for(var i = 0; i < this.$root.registry.collections.length; i++){
                var r = this.$root.registry.collections[i];
                if(r.name == colName){
                    if(r.opts) options = r.opts;
                    break;
                }
            }
            return options
        },
        loadBidirectionalData: function(registry_record, registryIdentifier, registryCollection){
            var vm = this;

            console.log('DISABLE SYNC? ', front_end_configs.default_preferences.disableSync)
            if(!front_end_configs.default_preferences.disableSync){
                console.log('VALUE SYNC: ', front_end_configs.default_preferences.disableSync)
                let needReload = false;
                if(!registry_record || registry_record.length == 0){
                    console.log("First Load")
                    needReload = true;
                } else {
                    console.log(registry_record)
                    var areTherePendingChanges = this.$root.dbRegistry.serializeChanges()
                    areTherePendingChanges = JSON.parse(areTherePendingChanges)
                    if(areTherePendingChanges && areTherePendingChanges.length > 0){
                        console.log("Pending changes detected: ", areTherePendingChanges)
                        needReload = false;
                    } else {
                        console.log("No pending changes detected")
                        needReload = true;
                    }
                }
                new Promise(function(resolve, reject){
                    console.log(needReload)
                    if(!needReload){
                        console.log("**** DO NOT RELOAD ****")
                        resolve()
                    } else {
                        console.log("**** RELOAD ****")
                        var bidirectional = [{
                            name: "orders",
                            command: "GetOrders"
                        },{
                            name: "orderItems",
                            command: "GetOrderItems"
                        },{
                            name: "addresses",
                            command: "GetAddresses"
                        },{
                            name: "users",
                            command: "GetUsers"
                        }]

                        if(!registry_record || registry_record.length == 0){
                            registryCollection.insert({"name": registryIdentifier, "lastSync": null})
                        } else {
                            //al secondo giro la data di lastSync mi viene passata dal server e da questo momento in poi uso sempre quella
                            //registry_record[0].lastSync = Date.now();
                            console.log('*************',registry_record[0].lastSync)
                        }
                        var bidPromises = [];
                        for(let i = 0; i < bidirectional.length; i++){
                            bidPromises.push(vm.$root.microservice({
                                serviceType: "registry",
                                role: "data",
                                cmd: bidirectional[i].command,
                                params: {}
                            }).then((response) => {
                                var res = response.body;
                                /*try {
                                    res = JSON.parse(response.body);
                                } catch (err) {}*/
                                console.log("Filling bid collection: ", bidirectional[i])
                                if(res){
                                    if (vm.$root.dbRegistry.getCollection(bidirectional[i].name)) { 
                                        vm.$root.dbRegistry.removeCollection(bidirectional[i].name);
                                    }
                                    var options = vm.getOpts(bidirectional[i].name);
                                    var c = vm.$root.dbRegistry.addCollection(bidirectional[i].name, options);
                                    c.insert(res)
                                }
                            }));
                        }

                        Promise.all(bidPromises).then(() => {
                            resolve()
                        }, (err) => {
                            console.log("Error loading bidirectional data: ", err)
                            resolve()
                        })
                    }
                }).then(() => {
                    console.log("***************************")
                    console.log(vm.$root.registry)
                    if(needReload){
                        console.log("Clearing changes")
                        vm.$root.dbRegistry.clearChanges()
                        console.log(vm.$root.dbRegistry)
                    }
                    
                    vm.$root.dbRegistry.saveDatabase(function(err){
                        if(err){
                            console.log("error saving bi-dir collections in IDb: ", err)
                        } 
                        console.log('bidirectional collections correctly written in IDb', vm.$root.dbRegistry)
                        if(vm.$root.shopCartData == null){
                            if(!vm.$Configs.ecp.ecidUrl){
                                vm.$root.newCart('start'); //se è stato passato il link e-commerce, non inizializzo il carrello
                            }
                        }
                        
                        var millisec;
                        if(vm.$root.preferences.deferredInterval){
                            millisec = Number(vm.$root.preferences.deferredInterval) * 1000 * 60 // (ms - s - m)
                        } else {
                            millisec = 60000
                        }
                        vm.$Sync.startSyncDefferredPolling(millisec);
                        /*
                        var randomizeTrigger = function(ms){
                            vm.$Sync.triggerUpdate()
                            setTimeout(function(){
                                var millisecTrigger = Math.floor(Math.random() * 2) * 1000 * 60; // da zero a due minuti
                                console.log("TRIGGER fra secs " + (millisecTrigger / 1000))
                                randomizeTrigger(millisecTrigger)
                            }, ms)
                        }
                        randomizeTrigger(1.5 * 1000 * 60);
                        console.log("TRIGGER fra secs " + (1.5 * 60))
                        */

                        /*
                        setTimeout(function(){
                            console.log("TEST")
                            //TODO: TEST
        
                            var update = vm.$root.dbRegistry.getCollection("orders").find({
                                "id": 3455
                            })
                            update[0].fax = "1521CCC1521"
                            vm.$root.dbRegistry.getCollection("orders").update(update);
                            var update2 = vm.$root.dbRegistry.getCollection("orderItems").find({
                                "id": 7694
                            })
                            update2[0].unp = 7.619
                            vm.$root.dbRegistry.getCollection("orderItems").update(update2);
                            
                            vm.$root.dbRegistry.getCollection("orderItems").insert({
                                cid: "013115",
                                ibu: true,
                                id: 1521000,
                                ide: "76",
                                mdt: Date.now(),
                                mqt: 1,
                                oid: 3455,
                                pid: "59900192",
                                qty: 1,
                                sta: "Da quotare",
                                unp: 1.00,
                                ulp: 100,
                                uni: "Pezzi"
                            })

                            console.log("******************************")
                            vm.$root.dbRegistry.saveDatabase(function(err){
                                console.log("SAVED TEST")
                            })
                        }, 10000)
                        */
                    });  
                })
            }else{
                console.log("AppOnlineLoaderMixin.js - SYNC HAS BEEN DISABLED BY CONFIG")
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/AppOnlineLoaderMixin.js